export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Premium%20minimalist%20fashion%20product%20photography%20flatlay%20with%20designer%20sneakers%20hoodies%20accessories%20and%20bags%20arranged%20on%20warm%20beige%20backdrop%20soft%20natural%20window%20light%20editorial%20composition%20clean%20aesthetic%20luxury%20shopping%20concept%20high%20detail%20professional%20product%20styling%20with%20organic%20textures%20and%20neutral%20tones&width=1600&height=900&seq=basetao-hero-v2&orientation=landscape"
        alt="Basetao Spreadsheet Resource Hub Background"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/50"></div>

      <div className="relative z-10 w-full px-6 md:px-10 text-center">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight max-w-4xl mx-auto">
          The Ultimate Basetao Spreadsheet Resource Hub
        </h1>
        <p className="mt-5 text-base md:text-lg text-white/85 max-w-2xl mx-auto leading-relaxed">
          Find organized Basetao Spreadsheet resources, product research guides, shipping information and expert reviews to make smarter purchasing decisions.
        </p>

        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="whitespace-nowrap cursor-pointer px-8 py-3.5 rounded-full bg-white text-foreground-900 font-semibold text-sm transition-all duration-300 hover:bg-white/90"
          >
            Basetao Spreadsheet
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="whitespace-nowrap cursor-pointer px-8 py-3.5 rounded-full bg-white/15 backdrop-blur-sm text-white border border-white/30 font-semibold text-sm transition-all duration-300 hover:bg-white/25"
          >
            Buy It Now
          </a>
        </div>

        <div className="mt-10 flex flex-wrap items-center justify-center gap-6">
          {['Updated Resources', 'Buyer Guides', 'Shipping Knowledge', 'Safety Information'].map((badge) => (
            <span key={badge} className="flex items-center gap-2 text-white/75 text-xs">
              <i className="ri-check-line text-accent-400 text-sm"></i>
              {badge}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}